'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Checks if provided value is an object
 * @param  {*} value - The value in question
 *
 * @return {Boolean} - True if value is an object
 */
var isObject = exports.isObject = function isObject(value) {
  return value === Object(value) && Object.prototype.toString.call(value) !== '[object Array]';
};